'use client';

import {ComponentProps, FC, useId} from 'react';

export const IconWehorseModerator: FC<ComponentProps<'svg'>> = ({...rest}) => {
    const id = useId();

    const maskId = `wehorseModeratorMask-${id}`;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
            viewBox="0 0 18 18"
            {...rest}
        >
            <rect
                width="18"
                height="18"
                fill="var(--raw-primary-brand)"
                rx="4"
            />
            <mask
                id={maskId}
                width="12"
                height="12"
                x="3"
                y="3"
                maskUnits="userSpaceOnUse"
                style={{maskType: 'alpha'}}
            >
                <path
                    fill="var(--color-icon-invert-fixed)"
                    d="M3 3.802h12v10.397H3V3.802Z"
                />
            </mask>
            <g
                fill="var(--color-icon-invert-fixed)"
                fillRule="evenodd"
                clipRule="evenodd"
                mask={`url(#${maskId})`}
            >
                <path d="m7.168 14.201 3.886-2.238-1.163-1.785-2.403-3.511-.744.99-1.067-.874.004 1.42L3 12.273l.643 1.012 3.358-1.618.167 2.534Z" />
                <path d="M15.002 8.976v-.003a1.212 1.212 0 0 0-.328-.794 2.531 2.531 0 0 0-.623-.481c-.218-.127-.435-.233-.616-.337l-1.337-.775c-.466-.27-.933-.534-1.396-.801-.615-.356-1.23-.716-1.847-1.072-.386-.223-.78-.48-1.212-.689a2.695 2.695 0 0 0-.42-.169 1.267 1.267 0 0 0-.357-.053 1.142 1.142 0 0 0-1.084.806 2.425 2.425 0 0 0-.094.739V5.993h.589V5.349c0-.206.014-.402.066-.56a.55.55 0 0 1 .714-.368c.105.03.214.078.33.134.388.187.77.434 1.172.667l.004.003-.003-.002c.616.355 1.23.715 1.847 1.072.466.269.933.534 1.396.801l1.337.774c.206.12.421.224.615.337.193.112.362.232.48.365a.633.633 0 0 1 .178.402v.002a.614.614 0 0 1-.162.385c-.172.206-.493.36-.82.547-.343.2-.69.398-1.037.6h.001l-.951.548.293.51c.318-.182.636-.365.953-.549l.004-.002-.003.002 1.037-.6c.284-.17.672-.332.97-.672.173-.203.301-.467.303-.767v-.002Z" />
            </g>
        </svg>
    );
};
